import React, { useState, useCallback, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import '../../index.css'
import Modal from '../../components/Modal/Modal'
import NeoButton from '../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import NeoLoader from '../../components/FormComponents/NeoLoader'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import BeneficiaryService from '../../services/beneficiary.service'
import NumberFormat from 'react-number-format'
import OtpInput from 'react-otp-input'
import 'custom/styles/color_variable.css'
import { BUTTON_KEYS, VIEW_SCHEDULED_PAYMENT_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

export default function ViewScheduledPayments() {
  const [error, setError] = useState('')
  const [expanded, setExpanded] = useState(null)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  // const [loadingSideBar, setLoadingSideBar] = useState(false)
  const [stage, setStage] = useState(0)
  const [scheduledList, setScheduledList] = useState([])
  const [selectedScheduledDetails, setSelectedScheduledDetails] = useState({})
  const [otp, setOtp] = useState('')
  const [randomKey, setRandomKey] = useState('')
  const { t } = useTranslation()

  const [showOtpModal, hideOtpModal] = useModal(
    () => (
      <Modal>
        <div className='my-4 py-4 d-flex xsflex-column text-center'>
          <div className='col-8 mx-auto'>
            <div className='form-group colored-input'>
              <h4 className='font-weight-bold' style={{ marginBottom: 20 }}>
                {t(VIEW_SCHEDULED_PAYMENT_KEYS.ENTER_OTP)}
              </h4>
              <OtpInput
                value={otp}
                onChange={handleOTPChange}
                numInputs={4}
                separator={''}
                isInputNum={true}
                isInputSecure={true}
                shouldAutoFocus={true}
                containerStyle='justify-content-center'
                inputStyle={{
                  width: 48,
                  height: 48,
                  fontSize: 24,
                  marginLeft: 8,
                  marginRight: 8,
                  border: 'none',
                  borderRadius: 10,
                  backgroundColor: 'var(--otp-background)',
                  color: 'var(--otp-text)',
                  fontWeight: 800,
                  fontSize: 18,
                }}
              />
              <label className='control-label' style={{ marginTop: 15 }}>
                {t(VIEW_SCHEDULED_PAYMENT_KEYS.OTP)}
              </label>
            </div>
            <div className='mt-4 mx-auto px-0'>
              {loading ? (
                <NeoLoader />
              ) : (
                <NeoButton
                  text={t(BUTTON_KEYS.SUBMIT)}
                  disabled={otp.length !== 4}
                  type='button'
                  mode='newDesign'
                  onClick={confirmCancelScheduledPayment}
                />
              )}
            </div>
            <div className='back-cancel-style' onClick={() => hideOtpModal()}>
              {t(BUTTON_KEYS.CANCEL)}
            </div>
          </div>
        </div>
        {/* <NeoOTP otp={otp} setOTP={setOtp} onSubmit={confirmCancelScheduledPayment} loading={loading} /> */}
      </Modal>
    ),
    [otp],
  )

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code}</b> : {error?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  const [showMessageModal, hideMessageModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideMessageModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  const handleOTPChange = useCallback((val) => {
    setOtp(val)
  }, [])

  const viewScheduledPaymentsList = useCallback(async () => {
    try {
      setLoading(true)
      setStage(0)
      const response = await BeneficiaryService.viewScheduledPayments()
      if (response.status === 200) {
        setScheduledList(response.data['scheduledPaymentView'])
      }
      setStage(1)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setError(err)
      setStage(1)
      setScheduledList([])
    }
  }, [])

  useEffect(() => {
    viewScheduledPaymentsList()
  }, [])

  const verifyCancelScheduledPayment = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        setSelectedScheduledDetails(selected)
        const response = await BeneficiaryService.verifyCancelScheduledPayments(selected)
        if (response.status === 200) {
          setRandomKey(response?.data?.randomKey)
          if (response?.data?.otpEnable) {
            showOtpModal()
            setLoading(false)
            return
          }
          const response1 = await BeneficiaryService.confirmCancelScheduledPayments({
            otp: '0000',
            randomKey: response.data.randomKey,
            srcAccountNo: selected.srcAccountNo,
            amount: selected.amount,
            srcAccCcy: selected.srcAccCcy,
            id: selected.id,
          })
          if (response1.status === 200) {
            viewScheduledPaymentsList()
            setMessage(response1.data.message)
            showMessageModal()
          }
        }
        setLoading(false)
      } catch (err) {
        setLoading(false)
        setError(err)
      }
    },
    [showOtpModal, selectedScheduledDetails, setRandomKey],
  )

  const confirmCancelScheduledPayment = useCallback(async () => {
    try {
      setLoading(true)
      let reqParams = {
        otp: otp,
        randomKey: randomKey,
        srcAccountNo: selectedScheduledDetails.srcAccountNo,
        amount: selectedScheduledDetails.amount,
        srcAccCcy: selectedScheduledDetails.srcAccCcy,
        id: selectedScheduledDetails.id,
      }
      const response = await BeneficiaryService.confirmCancelScheduledPayments(reqParams)
      if (response.status === 200) {
        hideOtpModal()
        viewScheduledPaymentsList()
        setMessage(response.data.message)
        showMessageModal()
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setError(err)
      setOtp('')
    }
  }, [otp, selectedScheduledDetails, message, randomKey])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        {loading && renderLoading()}
        {scheduledList.length > 0 && (
          <div>
            {scheduledList.map((item, index) => (
              <div
                key={index}
                className='loan-card '
                onClick={() => (expanded === index ? setExpanded(null) : setExpanded(index))}>
                <div className='loan-header'>
                  <div>
                    <span>
                      {t(VIEW_SCHEDULED_PAYMENT_KEYS.DESTINATION_ACCOUNT)} :{' '}
                      {item?.destinationAccount}
                    </span>
                    <div style={{ display: 'flex' }}>
                      <span>{t(VIEW_SCHEDULED_PAYMENT_KEYS.SCHEDULED_DATE)}: </span>
                      <span style={{ marginLeft: 5 }}>
                        {moment(item.scheduledDate).format('DD-MM-YYYY')} &nbsp;{''}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div className='d-flex' style={{ justifyContent: 'end' }}>
                      <label style={{ fontSize: '6px' }}>{item?.txnCcy}</label>
                      &nbsp;
                      <NumberFormat
                        value={item?.amount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        className='float-right'
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                    </div>
                    {/* <div>
                    <span>{item?.transferType}</span>
                  </div> */}
                  </div>
                </div>
                {expanded === index && (
                  <div className='loan-details'>
                    <div className='row beneficiary-details justify-space-between '>
                      <div className='col-12'>
                        <div className='row'>
                          <div className='col-4'>
                            <div className='label'>
                              {t(VIEW_SCHEDULED_PAYMENT_KEYS.SOURCE_ACCOUNT)}
                            </div>
                            <div className='value'>{item?.srcAccountNo}</div>
                          </div>

                          <div className='col-4'>
                            <div className='label'>
                              {t(VIEW_SCHEDULED_PAYMENT_KEYS.DESTINATION_ACCOUNT)}
                            </div>
                            <div className='value'>{item?.destinationAccount}</div>
                          </div>

                          <div className='col-4'>
                            <div className='label'>{t(VIEW_SCHEDULED_PAYMENT_KEYS.AMOUNT)}</div>
                            <div className='value'>
                              <NumberFormat
                                value={item?.amount}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={''}
                                fixedDecimalScale={true}
                                decimalScale={2}
                                allowEmptyFormatting
                              />
                            </div>
                          </div>

                          <div className='col-4'>
                            <div className='label'>
                              {t(VIEW_SCHEDULED_PAYMENT_KEYS.ACTIVE_STATUS)}
                            </div>
                            <div className='value'>
                              {item?.activeStatus === 'A' ? 'Pending' : 'Completed'}
                              {/* {item?.activeStatus === 'A' && 'Pending'}
                            {item?.activeStatus === 'C' && 'Cancelled'}
                            {item?.activeStatus === 'I' && 'Completed'} */}
                            </div>
                          </div>

                          <div className='col-4'>
                            <div className='label'>
                              {t(VIEW_SCHEDULED_PAYMENT_KEYS.SCHEDULED_DATE)}
                            </div>
                            <div className='value'>
                              {moment(item.scheduledDate).format('DD-MM-YYYY')} &nbsp;{''}
                            </div>
                          </div>

                          <div className='col-4'>
                            <div className='label'>
                              {t(VIEW_SCHEDULED_PAYMENT_KEYS.CREATED_DATE)}
                            </div>
                            <div className='value'>
                              {moment(item?.createdDate).format('DD-MM-YYYY') || '-'}
                            </div>
                          </div>

                          <div className='col-4'>
                            <div className='label'>{t(VIEW_SCHEDULED_PAYMENT_KEYS.TXN_STATUS)}</div>
                            <div className='value'>{item?.txnStatus || '-'}</div>
                          </div>

                          <div className='col-4'>
                            <div className='label'>
                              {t(VIEW_SCHEDULED_PAYMENT_KEYS.TXN_CURRENCY)}
                            </div>
                            <div className='value'>{item?.txnCcy || '-'}</div>
                          </div>
                          <div className='col-4'>
                            <div className='label'>{t(VIEW_SCHEDULED_PAYMENT_KEYS.REMARKS)}</div>
                            <div className='value'>{item?.remarks || '-'}</div>
                          </div>
                        </div>

                        <div class='row'>
                          {item.activeStatus === 'A' && (
                            <h6
                              className='download-link'
                              disabled={loading}
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                verifyCancelScheduledPayment(item)
                              }}>
                              {t(BUTTON_KEYS.CANCEL)}
                            </h6>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* {isOtpModal && (
        <NeoOTP 
        setOTP={setOtp}
        loading={loading}
        otp={otp}
        onSubmit={scheduledPaymentConfirm}
        />
        )} */}

        {scheduledList.length === 0 && (
          <div className='no-data-found'>{t(VIEW_SCHEDULED_PAYMENT_KEYS.NO_RECORDS_FOUND)}</div>
        )}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='SCHEDULED_PAYMENTS'
      showEmptySpace={true}
      keyPath={'SCHEDULED_PAYMENTS'}>
      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
